export default __webpack_public_path__ + "static/media/BUYING 2.3c8eb7e6.png";